import React from "react";
import PropTypes from "prop-types";
import { withRouter } from "react-router-dom";
import "./TopNavigation.css";

class TopNavigation extends React.Component {
  handleBackClick = () => {
    this.props.history.goBack();
  };

  getPageTitle = () => {
    let titleName = this.props.location.pathname.substring(1);

    if (titleName.indexOf("packages") !== -1)
      titleName =
        "packages: " + titleName.substring(titleName.indexOf("/") + 1);

    return titleName.toUpperCase();
  };

  render() {
    return (
      <div className="topNav">
        <div onClick={this.handleBackClick}>
          <i className="material-icons">keyboard_backspace</i>
        </div>
        <span>{this.getPageTitle()}</span>
        <i className="material-icons">search</i>
      </div>
    );
  }
}

TopNavigation.propTypes = {
  title: PropTypes.string
};

export default withRouter(TopNavigation);
